"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApLegendItem = void 0;
var React = require("react");
var theme_1 = require("../../utils/theme");
var types_1 = require("../../utils/types");
var styles_1 = require("./styles");
exports.ApLegendItem = function (_a) {
    var alignment = _a.alignment, bulletColor = _a.bulletColor, children = _a.children, className = _a.className;
    return (React.createElement(styles_1.StyledLegendItem, { className: "ap-legend-item " + (className ? className : ''), alignment: alignment, bulletColor: bulletColor }, children));
};
exports.ApLegendItem.defaultProps = {
    alignment: types_1.LEFT,
    bulletColor: theme_1.colors.green1
};
//# sourceMappingURL=ApLegendItem.js.map